import {StyleSheet} from 'react-native';

export const buttonsStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
  },
  btnValiderOuterSinistre: {
    width: 200,
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    paddingHorizontal: 30,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
  },
  btnValiderOuterProfil: {
    width: 280,
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    paddingHorizontal: 30,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
  },
  displayCenterP: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    marginTop: 30,
    paddingBottom: 10,
  },
  displayCenterProfil: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
  },
  displayCenterImageLogin: {
    height: 160,
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flex: 1,
    marginTop: 10,
    marginBottom: 10,
  },
  displayCenterInscriptionImage: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flex: 1,
    marginTop: 30,
    marginBottom: 10,
    height: 60,
  },
  ButtonGreen: {
    marginLeft: 20,
    padding: 16,
    backgroundColor: 'rgba(240, 244, 248, 0.875)',
    borderRadius: 30,
    shadowColor: 'rgba(0, 0, 0, 0.06)',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.001,
    shadowRadius: 10,
    elevation: 5,
    marginVertical: 10,
    flexDirection: 'row',
  },
  ButtonGreenTxt: {
    fontSize: 16,
    fontWeight: '700',
    color: '#1D5C42',
    marginHorizontal: 5,
  },
  ButtonGreenImg: {
    width: 24,
    height: 24,
    resizeMode: 'contain',
    marginHorizontal: 5,
  },
  ButtonGreenNoLabel: {
    paddingHorizontal: 4,
    paddingVertical: 8,
    backgroundColor: 'rgba(240, 244, 248, 0.875)',
    borderRadius: 30,
    shadowColor: 'rgba(0, 0, 0, 0.06)',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.001,
    shadowRadius: 10,
    elevation: 5,
    marginVertical: 10,
    width: 40,
    height: 40,
  },
  ButtonGreenNoText: {
    width: 40,
    height: 40,

    paddingHorizontal: 4,
    paddingVertical: 8,
    backgroundColor: 'rgba(240, 244, 248, 0.875)',
    borderRadius: 30,
    shadowColor: 'rgba(0, 0, 0, 0.06)',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.001,
    shadowRadius: 10,
    elevation: 5,
    marginVertical: 10,
    flexDirection: 'row',
  },
  appButton: {
    color: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: 50,
  },
  appButtonContainer: {
    flexDirection: 'row',
    marginVertical: 4,
    marginRight: 4,
    marginLeft: 4,
  },
  appButtonContainerBtn: {
    minWidth: 120,
    margin: 15,
    padding: 10,
  },
  btnAnnulerOuter: {
    minWidth: 120,
    backgroundColor: '#F9FCFF',
    borderRadius: 30,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: 'rgba(240, 244, 248, 0.875)',
    shadowColor: '#fafafa',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.01,
    shadowRadius: 0,
    elevation: 0,
    marginVertical: 8,
    flexGrow: 0,
    flexShrink: 1,
  },
  btn: {
    color: '#58A618',
    fontSize: 16,
    fontWeight: '700',
    textAlign: 'center',
    marginHorizontal: 8,
  },
  btnValiderOuter: {
    minWidth: 130,
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    paddingHorizontal: 4,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginVertical: 8,
    flexGrow: 0,
    flexShrink: 1,
  },
  btnValider: {
    paddingHorizontal: 4,
    color: '#fff',
    textAlign: 'center',
  },
  validate: {
    backgroundColor: '#23a4ea',
    minWidth: 120,
  },
  inValidate: {
    minWidth: 120,
    backgroundColor: 'gray',
    color: 'black',
  },
  btnValidate: {
    minWidth: 120,
    marginRight: 4,
    marginLeft: 4,
    paddingLeft: 4,
    paddingRight: 4,
  },
  btnDisable: {
    backgroundColor: '#D3D3D3',
  },
  displayCenter: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    marginTop: 30,
    paddingBottom: 10,
  },
  displayCenterMobile: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    marginTop: 30,
  },
  btnAnnuler: {
    color: '#58A618',
    fontSize: 16,
    fontWeight: '700',
    textAlign: 'center',
    paddingHorizontal: 0,
    marginHorizontal: 8,
  },
  displaySpacedBtween: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
  },
  displayHorizontal: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    marginVertical: 16,
  },
  displayCenterLoginBottom: {
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flex: 1,
    marginTop: 0,
    marginBottom: 0,
    height: 40,
  },
  btnTabWrapper: {
    marginVertical: 15,
    borderRadius: 30,
    flex: 1,
    height: 50,
    maxHeight: 50,
    flexDirection: 'row',
    flexWrap: 'nowrap',
    backgroundColor: 'rgba(240, 244, 248, 0.875)',
    borderWidth: 1,
    borderColor: 'rgba(224, 224, 224, 1)',
    justifyContent: 'center',
    alignItems: 'stretch',
    alignContent: 'stretch',
  },
  btnTabOuter: {
    height: 50,
    borderRadius: 30,
    flex: 1,
    margin: 0,
    display: 'flex',
    paddingHorizontal: 5,
    width: '100%',
  },
  btnTabOuterActive: {
    height: 50,
    borderRadius: 30,
    flex: 1,
    backgroundColor: 'rgba(29, 92, 66, 1)',
    margin: 0,
    display: 'flex',
    width: '100%',
    paddingHorizontal: 5,
  },
  btnTabTxt: {
    fontSize: 16,
    color: 'rgba(0, 0, 0, 1)',
  },
  btnTabTxtActive: {
    fontSize: 16,
    color: 'rgba(255, 255, 255, 1)',
  },
  btnAnnulerOuterSimu: {
    minWidth: 120,
    backgroundColor: '#F9FCFF',
    borderRadius: 30,
    paddingHorizontal: 4,
    borderWidth: 1,
    borderColor: 'rgba(240, 244, 248, 0.875)',
    shadowColor: '#fafafa',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.01,
    shadowRadius: 0,
    elevation: 0,
    marginVertical: 8,
    marginHorizontal: 4,
  },
  btnValiderOuterSimu: {
    minWidth: 120,
    backgroundColor: '#0f579e',
    borderRadius: 30,
    height: 50,
    paddingHorizontal: 4,
    shadowColor: 'rgba(15, 87, 158, 0.9)',
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.4,
    shadowRadius: 7,
    elevation: 5,
    marginHorizontal: 4,
    marginVertical: 8,
  },
});
